import { CONSTANTS } from "../../constants";
function getAuthPageUrl() {
    var redirectUrl = new URL(CONSTANTS.authUrl + '/signin');
    redirectUrl.searchParams.append('redirectUrl', window.location.href);
    redirectUrl.searchParams.append('urlPrefix', URL_PREFIX);
    return redirectUrl.toString();
}
function redirectToAuthPage() {
    window.location.replace(getAuthPageUrl());
    return true;
}
export { getAuthPageUrl, redirectToAuthPage };
//# sourceMappingURL=index.js.map